import { axiosFactory } from '../../../client';
import * as Routes from './routes';
import { ApplicationFilesConfig } from '../model';
import { ApplicationType } from '../../../candidate/config/model';

const baseApiUrl = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/`;
const timeout = 1000;

export const attachedFileClient = axiosFactory(baseApiUrl, timeout);

export const deleteAttachedFile = (tokenCsrf: string, uuid: string) =>
  attachedFileClient.delete<string>(tokenCsrf, `${Routes.DELETE_ATTACHED_FILE(uuid)}`);

export const getApplicationFilesConfig = (applicationType: ApplicationType) =>
  attachedFileClient.get<ApplicationFilesConfig>(
    Routes.GET_APPLICATION_FILES_CONFIG(applicationType)
  );
